import { useTranslation } from 'react-i18next';
import { SegmentedControl } from '~/components/segmented-control';
import { TierTable } from '~/components/tier-table';
import type { Tier, TierMode } from '~/lib/schemas/actions';

interface TierFieldsValue {
	tierMode: TierMode;
	tiers: Tier[];
}

interface TierFieldsProps {
	value: TierFieldsValue;
	onChange: (next: TierFieldsValue) => void;
	valueLabel: 'percent' | 'amount' | 'price';
}

/** Shared tier editor for the tier-family actions (percentage / value / fixed-price). */
export function TierFields({ value, onChange, valueLabel }: TierFieldsProps) {
	const { t } = useTranslation();
	const mode = value.tierMode === 'byQuantity' ? 'quantity' : 'amount';

	return (
		<div className="flex flex-col gap-3">
			<SegmentedControl
				value={value.tierMode}
				onValueChange={tierMode =>
					// Collapsing to a single tier when switching to fixed.
					onChange({ tierMode, tiers: tierMode === 'fixed' && value.tiers.length > 1 ? [value.tiers[0]] : value.tiers })
				}
				options={[
					{ value: 'fixed', label: t('promotion.action.tierMode.fixed') },
					{ value: 'byQuantity', label: t('promotion.action.tierMode.byQuantity') },
					{ value: 'byAmount', label: t('promotion.action.tierMode.byAmount') }
				]}
			/>
			<p className="text-xs text-foreground-muted">{t(`promotion.action.tierMode.help.${value.tierMode}`)}</p>
			<p className="text-sm font-semibold text-foreground">{t(`promotion.action.tierMode.sublabel.${value.tierMode}`)}</p>
			<TierTable
				tiers={value.tiers}
				onChange={tiers => onChange({ tierMode: value.tierMode, tiers })}
				mode={mode}
				valueLabel={valueLabel}
				hideThreshold={value.tierMode === 'fixed'}
			/>
		</div>
	);
}
